import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TrackingPageDefaultValues } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.models';
import { Shop } from '@services/shops/shop.model';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { capitalize, sanitizeString } from '@pdqdev/pdq-shared/dist/utils/rich-text-utils';

@Component({
  selector: 'tracking-page-preview',
  templateUrl: './tracking-page-preview.component.html',
  styleUrls: ['./tracking-page-preview.component.scss', '../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPagePreviewComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() couponCodeIndexToPreview: number = 0;
  @Input() unsuccessfulTrackingStatusColorPreviewButtonState: boolean = false;
  @Input() shop: Shop;

  accentColor: string = TrackingPageDefaultValues.settings.accentColor;
  isGrayscale: boolean = false;
  unsuccessfulTrackingStatusColor: string = TrackingPageDefaultValues.settings.unsuccessfulTrackingStatusColor;
  displayTrackingNumber: boolean = false;
  showTrackingProgress: boolean = false;
  showDestinationMap: boolean = false;
  displayMessageForUntrackedShipments: boolean = false;
  messageForUntrackedShipments: string = '';
  displayMessageWhenHandedOverToDifferentCarrier: boolean = false;
  messageWhenHandedOverToDifferentCarrier: string = '';
  trackingHistory = TrackingPageDefaultValues.trackingHistory;
  widgets: ShopPlugin.TrackingPage.Widgets = {
    couponCodes: [],
    productSection: {},
    details: {},
    simpleTracker: {
      showTrackingProgress: true,
      showFutureSteps: true,
    },
  };
  maxNumOfTrackingHistoryRows = 3;
  lineItems = TrackingPageDefaultValues.lineItems;
  defaultImage = '/assets/images/product-placeholder.png';
  currentTrackingStatusStepIndex = 1;

  constructor() {}

  ngOnInit(): void {
    console.log('couponCodeIndexToPreview', this.couponCodeIndexToPreview);
    this.initPreviewFieldsValueChanges();
  }

  private initPreviewFieldsValueChanges(): void {
    this.formGroup.valueChanges.subscribe((values) => {
      this.setFieldsValue(values.settings);
      this.widgets = values.widgets;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formGroup?.currentValue?.value) {
      const formValues = changes.formGroup.currentValue.value;
      if (formValues.settings) {
        this.setFieldsValue(formValues.settings);
      }
      if (formValues.widgets) {
        this.widgets = formValues.widgets;
      }
    }
    if (changes.unsuccessfulTrackingStatusColorPreviewButtonState) {
      this.unsuccessfulTrackingStatusColorPreviewButtonState =
        changes.unsuccessfulTrackingStatusColorPreviewButtonState.currentValue;
      this.currentTrackingStatusStepIndex = this.unsuccessfulTrackingStatusColorPreviewButtonState ? 4 : 1;
    }
  }

  private static readonly GRAYSCALE_ACCENT_COLOR = '#454572';

  private setFieldsValue(settings): void {
    this.isGrayscale = settings?.colorScheme === 'grayscale';
    this.accentColor = this.isGrayscale
      ? TrackingPagePreviewComponent.GRAYSCALE_ACCENT_COLOR
      : settings?.accentColor || this.accentColor;
    this.showDestinationMap = settings?.showDestinationMap ?? false;
  }

  formatBodyText(bodyText: string): string {
    if (!bodyText) return '';
    const processedText = sanitizeString(bodyText, { noLineBreaks: false, removePunctuation: true })
      .split('\n')
      .map((row) => capitalize(row));
    return processedText.join('<br>');
  }
}
